import { ProductContentsPane } from 'components/ProductContentsPane/ProductContentsPane';
import { ProductReviewsPane } from 'components/ProductReviewsPane/ProductReviewsPane';
import { ProductContentsViewProps } from 'lib/themes/themes';

const ProductContentsView = ({ product }: ProductContentsViewProps) => {
  return (
    <div className="base-single__main">
      <ProductContentsPane product={product} />
      <ProductReviewsPane product={product} />
    </div>
  );
};

export default ProductContentsView;
